import React, { useEffect, useState } from 'react';
import styles from './procedimentos_darcielalesquim_fotografias.module.scss';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaChevronLeft, FaChevronRight, FaWhatsapp } from 'react-icons/fa';

const WHATSAPP_NUMBER = '5517981800385';

const procedimentos = [
    {
        titulo: 'Gestante',
        descricao: 'Ensaio fotográfico para registrar a beleza e a emoção da gestação. Realizamos em estúdio ou externo, em um momento único que merece ser eternizado com sensibilidade e cuidado.',
        imagens: [require("./src/procedimento_1_1.png")] as string[],
        whatsappMessage: 'Olá! Gostaria de saber mais sobre Ensaio de Gestante e agendar uma sessão.',
    },
    {
        titulo: 'Parto',
        descricao: 'Cobertura fotográfica do parto para guardar os primeiros instantes do seu bebê. Trabalho discreto e respeitoso, capturando a chegada e as emoções da família nesse dia inesquecível.',
        imagens: [require("./src/procedimento_2_1.png"), require("./src/procedimento_2_2.png")] as string[],
        whatsappMessage: 'Olá! Gostaria de saber mais sobre Ensaio de Parto e agendar uma sessão.',
    },
    {
        titulo: 'Newborn',
        descricao: 'Sessão dedicada aos recém-nascidos, geralmente até os 15 dias de vida. Fotos delicadas com o bebê em poses seguras e aconchegantes, em ambiente preparado para conforto e tranquilidade.',
        imagens: [require("./src/procedimento_3_1.png"), require("./src/procedimento_3_2.png")] as string[],
        whatsappMessage: 'Olá! Gostaria de saber mais sobre Ensaio de Newborn e agendar uma sessão.',
    },
    {
        titulo: 'Acompanhamento mensal',
        descricao: 'Registro do crescimento do bebê mês a mês. Uma sessão por mês para documentar as mudanças, conquistas e expressões do primeiro ano de vida, criando um álbum de memórias completo.',
        imagens: [require("./src/procedimento_4_1.png"), require("./src/procedimento_4_2.png")] as string[],
        whatsappMessage: 'Olá! Gostaria de saber mais sobre Ensaio de Acompanhamento Mensal e agendar uma sessão.',
    },
    {
        titulo: 'Sessão de aniversario',
        descricao: 'Ensaio para celebrar mais um ano de vida. Fotos criativas e descontraídas que registram a personalidade e a alegria do aniversariante, em estúdio ou em locação à sua escolha.',
        imagens: [require("./src/procedimento_5_1.png"), require("./src/procedimento_5_2.png")] as string[],
        whatsappMessage: 'Olá! Gostaria de saber mais sobre Ensaio de Sessão de Aniversário e agendar uma sessão.',
    },
    {
        titulo: 'Aniversário infantil',
        descricao: 'Cobertura completa da festa de aniversário da criança. Registro dos preparativos, decoração, bolo, brincadeiras e da felicidade dos convidados, para você reviver cada momento depois.',
        imagens: [require("./src/procedimento_6_1.png"), require("./src/procedimento_6_2.png"), require("./src/procedimento_6_3.png")] as string[],
        whatsappMessage: 'Olá! Gostaria de saber mais sobre Ensaio de Aniversário Infantil e agendar uma sessão.',
    },
];

interface CardProcedimentoProps {
    titulo: string;
    descricao: string;
    imagens: string[];
    whatsappMessage: string;
}

const CardProcedimento: React.FC<CardProcedimentoProps> = ({
    titulo,
    descricao,
    imagens,
    whatsappMessage,
}) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const hasImages = imagens.length > 0;
    const hasMultipleImages = imagens.length > 1;

    const prevImage = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (!hasMultipleImages) return;
        setCurrentIndex((prev) => (prev === 0 ? imagens.length - 1 : prev - 1));
    };

    const nextImage = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (!hasMultipleImages) return;
        setCurrentIndex((prev) => (prev === imagens.length - 1 ? 0 : prev + 1));
    };

    const handleWhatsAppClick = () => {
        window.open(
            `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(whatsappMessage)}`,
            '_blank'
        );
    };

    return (
        <div className={styles.card}>
            <div className={styles.carouselContainer}>
                {hasImages ? (
                    <>
                        <img src={imagens[currentIndex]} alt={titulo} />
                        {hasMultipleImages && (
                            <>
                                <button
                                    type="button"
                                    className={`${styles.carouselBtn} ${styles.prevBtn}`}
                                    onClick={prevImage}
                                    aria-label="Imagem anterior"
                                >
                                    <FaChevronLeft />
                                </button>
                                <button
                                    type="button"
                                    className={`${styles.carouselBtn} ${styles.nextBtn}`}
                                    onClick={nextImage}
                                    aria-label="Próxima imagem"
                                >
                                    <FaChevronRight />
                                </button>
                                <div className={styles.indicators}>
                                    {imagens.map((_, idx) => (
                                        <span
                                            key={idx}
                                            role="button"
                                            tabIndex={0}
                                            className={`${styles.dot} ${idx === currentIndex ? styles.active : ''}`}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setCurrentIndex(idx);
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    setCurrentIndex(idx);
                                                }
                                            }}
                                            aria-label={`Ir para imagem ${idx + 1}`}
                                        />
                                    ))}
                                </div>
                            </>
                        )}
                    </>
                ) : (
                    <div className={styles.placeholderImagem}>
                        <span>Imagens em breve</span>
                    </div>
                )}
            </div>
            <h3>{titulo}</h3>
            {descricao ? <p className={styles.descricao}>{descricao}</p> : null}
            <button
                type="button"
                className={styles.whatsappBtn}
                onClick={handleWhatsAppClick}
            >
                <FaWhatsapp /> Falar no WhatsApp
            </button>
        </div>
    );
};

const Procedimentos_darcielalesquim_fotografias: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.pageWrapper}>
            <div className={styles.procedimentos_darcielalesquim_fotografias}>
                <div className={styles.header}>
                    <Link to="/darcielalesquim_fotografias" className={styles.backButton} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                    <h2>Galeria</h2>
                </div>
                <div className={styles.lista}>
                    {procedimentos.map((item, index) => (
                        <CardProcedimento
                            key={index}
                            titulo={item.titulo}
                            descricao={item.descricao}
                            imagens={item.imagens}
                            whatsappMessage={item.whatsappMessage}
                        />
                    ))}
                </div>
            </div>
            <div className={styles.footer}>
                <img
                    src={require('./src/logo.png')}
                    alt="Darciela Lesquim Fotografias"
                    className={styles.footerLogo}
                />
            </div>
        </div>
    );
};

export default Procedimentos_darcielalesquim_fotografias;
